import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable } from 'rxjs';

export type Dictionnaire = TranslationObject;

/**
 * Un dictionnaire par langue : `assets/i18n/<lang>.json`. Les libellés du
 * CRM y vivent sous la clé `CRM` (décision du 2026-10-07 : pas de fichiers
 * de domaine séparés).
 */
export class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) { }

  getTranslation(lang: string): Observable<Dictionnaire> {
    return this.http.get<Dictionnaire>(`./assets/i18n/${lang}.json`);
  }
}
